<template>
  <div>
    <el-form-item label="输入类型">
      <el-select v-model="value.inputType"
                 :disabled="disabled"
                 placeholder="请选择"
                 @change="onChangeInputType">
        <el-option :label="item.label"
                   :value="item.value"
                   v-for="(item,key) in inputType"
                   :key="key"></el-option>
      </el-select>
    </el-form-item>

    <!--   输入范围   -->
    <template>
      <el-form-item v-if="value.inputType === 'date'"
                    label="可输入最早日期">
        <el-date-picker
          v-model="value.inputMin"
          :disabled="disabled"
          type="date"
          format="yyyy-MM-dd"
          value-format="timestamp"
          :picker-options="dateTimePickerOptions"
          placeholder="最早日期"
          align="center"
          style="width: 140px;">
        </el-date-picker>
      </el-form-item>

      <el-form-item v-if="value.inputType === 'date'"
                    label="可输入最晚日期">
        <el-date-picker
          v-model="value.inputMax"
          :disabled="disabled"
          type="date"
          format="yyyy-MM-dd"
          value-format="timestamp"
          :picker-options="dateTimePickerOptions"
          placeholder="最晚日期"
          align="center"
          style="width: 140px;">
        </el-date-picker>
      </el-form-item>

      <el-form-item v-else
                    label="输入范围">
        <el-input v-model="value.inputMin"
                  :disabled="disabled"
                  @change="_ => value.inputMin = changeNumber(_)"
                  placeholder="最小/短"
                  style="width: 82px;">
        </el-input>
        ~
        <el-input v-model="value.inputMax"
                  :disabled="disabled"
                  @change="_ => value.inputMax = changeNumber(_)"
                  placeholder="最大/长"
                  style="width: 82px;">
        </el-input>
      </el-form-item>
    </template>
  </div>
</template>

<script>
import dateTimePicker from '@core/mixins/dateTimePicker'

export default {
  components: {},
  mixins: [dateTimePicker],
  inject: ['scope'],
  props: {
    value: Object,
    disabled: Boolean,
  },
  data () {
    return {}
  },
  computed: {
    ...Vuex.mapState('stepTemplate', {
      inputType: state => state.inputType,
    }),
  },
  watch: {},
  created () {},
  mounted () {},
  methods: {
    changeNumber (value) {
      if (typeof value === 'string') {
        value = value.toString().replace(/[^-\\.\d]/g, '')
      }
      if (value === '' || isNaN(value)) {
        return null
      }
      return Number(value)
    },
    onChangeInputType () {
      this.value.inputMin = null
      this.value.inputMax = null
    }
  },
  filters: {},
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/step-template/components/attrs/AttrInputType.vue